export default function () {
  return [
    {
      title: '姓名',
      width: 120,
      [$field]: 'memberUserName',
    },
    // {
    //   title: '工号',
    //   width: 120,
    //   [$field]: 'memberUserId',
    // },
    {
      title: '贡献度',
      isEdit: true,
      [$field]: 'contributionDegree',
      showType: 'numberInput',
      textRender: (item) => {
        return `${item.contributionDegree}%`
      }
    },
    {
      title: '项目角色',
      isEdit: true,
      [$field]: 'projRole'
    },
    {
      title: '积分',
      isEdit: true,
      [$field]: 'bonusPoints',
      showType: 'numberInput'
    },
    {
      title: '操作',
      width: 120,
      [$field]: 'operate',
      isOperate: true
    }
  ]
}
